import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import GoogleIcon from '@mui/icons-material/Google';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import Select from '@mui/material/Select';
import { UserService } from '../service/UserService';
import {Link, useNavigate} from "react-router-dom";
import {Checkbox, Container, Divider, InputAdornment, Stack} from "@mui/material";
import moment from 'moment';
import IconButton from "@mui/material/IconButton";
import * as PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import RegistrationDialog from "./RegistrationDialog";
const maxLogin = 5;
const maxDelayTime = 2000;

function Iconify(props) {
    return null;
}

Iconify.propTypes = {icon: PropTypes.any};
export default function LogInDialog(props) {
    let tries = 0;
    let delayTime=0;
    function updateTry(){
        if(tries===maxLogin){
            if(moment().seconds()-delayTime>=maxDelayTime){
                delayTime=moment().seconds();
                tries = 0;
            }
            return false;
        }
        tries=tries+1;
        delayTime=moment().seconds();
        return true;
    }
    // const [open, setOpen] = React.useState(true);

    // const handleClickOpen = () => {
    //   setOpen(true);
    // };

    // const handleClose = () => {
    //   setOpen(false);
    // };
    const navigate = useNavigate();
    // handle type
    const [usertype, setType] = React.useState(0);
    const [showPassword,setShowPassword] = React.useState(false);
    const [loginState] = React.useState(false);

    const handleChange = (event) => {
        setType(event.target.value);
        // console.log(event.target.value);
    };
    const check = (event) =>{

            props.history.push('registration')

    }

    // use ref to get input
    const [username, password, email, phone] = [React.useRef(), React.useRef(), React.useRef(), React.useRef()]



    // register function
    function login() {
        // TODO: check formation
        // TODO: write to db by service
        // const userInfo = {
        //   "name": username.current.value,
        //   "password": password.current.value,
        //   "type": usertype,
        //   "email": email.current.value,
        //   "phone": phone.current.value
        // }

        // UserService.registerUser(userInfo).then(response => {
        //   console.log(response.data);
        // }).catch(error => {
        //   console.log(error);
        // })
        let validCheck=updateTry();
        if(validCheck){
            UserService.loginUser(username.current.value, password.current.value, usertype, tries).then(response => {
                console.log(response.data);
            }).catch(error => {
                console.log(error);
            })

            // test to print out written values:
            console.log(username.current.value, password.current.value, email.current.value, phone.current.value, usertype);
            console.log(typeof username.current.value);
            console.log(typeof password.current.value);
            console.log(typeof email.current.value);
            console.log(typeof phone.current.value);
            console.log(typeof usertype);
        }

        props.handleClose();
    }

    return (
        <div>
            {/* <Button variant="outlined" onClick={handleClickOpen}>
        Open form dialog
      </Button> */}

            <Dialog open={props.open} onClose={props.handleClose}>
                <DialogTitle>Sign in to Lepton</DialogTitle>
                <DialogContent>

                    <Typography variant="body2" sx={{ mb: 5 }}>
                        Don’t have an account? {''}
                        <Link onClick={check} variant="subtitle2" replace >Get started</Link>
                    </Typography>

                    <Stack direction="row" spacing={2}>
                        <Button fullWidth size="large" color="inherit" variant="outlined">
                            {/*<Iconify icon="eva:google-fill" color="#DF3E30" width={22} height={22} />*/}
                            <GoogleIcon/>
                        </Button>

                        <Button fullWidth size="large" color="inherit" variant="outlined">
                            {/*<Iconify icon="eva:facebook-fill" color="#1877F2" width={22} height={22} />*/}
                            <FacebookIcon/>
                        </Button>

                        <Button fullWidth size="large" color="inherit" variant="outlined">
                            {/*<Iconify icon="eva:twitter-fill" color="#1C9CEA" width={22} height={22} />*/}
                            <TwitterIcon/>
                        </Button>
                    </Stack>

                    <Divider sx={{ my: 3 }}>
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                            OR
                        </Typography>
                    </Divider>



                    <DialogContentText>
                        Login as a Leptoner!
                    </DialogContentText>

                    <TextField id="standard-basic" required label="Username"
                               variant="standard" fullWidth autoFocus inputRef={username} />
                    <TextField id="standard-basic" required label="Password"
                               variant="standard" fullWidth
                               inputRef={password}
                               type={showPassword ? 'text' : 'password'}
                               InputProps={{
                                   endAdornment: (
                                       <InputAdornment position="end">
                                           <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                               <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                                           </IconButton>
                                       </InputAdornment>
                                   ),
                               }}/>

                    <InputLabel id="demo-simple-select-label">User Type</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={usertype}
                        label="Type"
                        onChange={handleChange}
                    >
                        <MenuItem value={1}>Composer</MenuItem>
                        <MenuItem value={2}>Audience</MenuItem>
                    </Select>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
                        <Checkbox name="remember" label="Remember me" />
                        <Link variant="subtitle2" underline="hover">
                            Forgot password?
                        </Link>
                    </Stack>

                </DialogContent>
                <DialogActions>
                    <Button onClick={login} variant={'contained'}>Log in</Button>
                    <Button onClick={props.handleClose} variant={'contained'}>Cancel</Button>
                </DialogActions>
            </Dialog>
        </div>


    );
}